import styled from "styled-components";

export const StyledPercentageSelectContainer = styled.div`
  width: 100px;
  display: flex;
  align-self: center;
`;

export const StyledBodyProgressPlan = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-top: 20px;
`;

export const StyledValutationQuadrantContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  border: 1px solid ${({ theme }) => theme.colors.purple_2};
  border-radius: 12px;
  overflow: hidden;
`;

export const StyledValutationQuadrantBody = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 5px 15px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.purple_2};

  &:nth-child(odd) {
    border-right: 1px solid ${({ theme }) => theme.colors.purple_2};
  }
`;

export const StyledValutationQuadrantSelect = styled.div`
  width: 60px;
  flex-shrink: 0;
`;

export const StyledValutationQuadrantTotal = styled(
  StyledValutationQuadrantBody,
)`
  && {
    grid-column: 1 / -1;
    border-bottom: none;
    border-right: none;
  }
`;

export const StyledRowIncreasing = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 15px;

  &:not(:last-child) {
    border-bottom: 1px solid ${({ theme }) => theme.colors.purple_2};
  }
`;

export const StyledIncreasingRadioGroup = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 20px;
`;

export const StyledIncreasingRadioOption = styled.label`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  cursor: pointer;
`;

export const StyledRowIncreasingContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 12px;
  border: 1px solid ${({ theme }) => theme.colors.purple_2};
  border-radius: 12px;
`;

export const StyledGridContainer = styled.div<{ $isComparison?: boolean }>`
  display: grid;
  grid-template-columns: ${({ $isComparison }) =>
    $isComparison ? "repeat(2, 1fr)" : "repeat(auto-fit, minmax(180px, 1fr))"};
  gap: 20px;
  align-items: start;
  padding: 30px 20px;
`;
